import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  FinancialPeriodSelect,
  HubHookCustomersSelect,
  HubHookFormFileInput,
  HubHookFormInput,
  HubHookFormPartSelectV2,
  HubHookFormSelect,
  HubHookFormSwitch,
  HubMaterialHookSelect,
} from "../../components";
import { FOUNDRIES } from "../../constants";
import { StyledCheckboxGrid } from "./styles";

const grindGates = [
  { id: 1, label: "Flush" },
  { id: 2, label: "Witness" },
];

const handBlastingOptions = [
  {
    id: 0,
    label: "0 - Not Required",
  },
  {
    id: 1,
    label: "1 - Yes But Easy",
  },
  {
    id: 2,
    label: "2 - Medium",
  },
  {
    id: 3,
    label: "3 - Holes",
  },
];

const moldTypes = ["Manual", "Automatic"]?.map((label, id) => ({
  id,
  label,
}));

const checkboxes = [
  {
    id: "handDipping",
    label: "Hand Dipping",
  },
  {
    id: "flashing",
    label: "Flashing",
  },
  {
    id: "hardToFixture",
    label: "Hard to Fixture",
  },
  {
    id: "weldRepair",
    label: "Weld Repair",
  },
  {
    id: "fineDetail",
    label: "Fine Detail",
  },
  {
    id: "straightening",
    label: "Straightening",
  },
];

const QuoteDialogForm = () => (
  <Stack gap="25px" padding="25px">
    <Stack gap="5px">
      <Typography variant="boldCaptionL" fontSize="16px">
        Part
      </Typography>
      <Stack gap="10px">
        <Stack direction="row" gap="10px">
          <HubHookFormFileInput name="model" label="Model" />
          <HubHookFormFileInput name="setup" label="Setup" />
        </Stack>
        <HubHookCustomersSelect required="false" />
        <HubHookFormPartSelectV2
          name="partId"
          label="Existing Part"
          required={false}
        />
        <Stack direction="row" gap="10px">
          <HubHookFormInput
            name="partName"
            label="Part Name"
            placeholder="New part name"
          />
          <HubHookFormInput
            name="partNumber"
            label="Part Number"
            placeholder="New part number"
          />
          <HubHookFormInput
            name="weight"
            label="Weight"
            placeholder="0.00"
            endAdornment="lbs"
          />
        </Stack>
      </Stack>
    </Stack>

    <Stack gap="5px">
      <Typography variant="boldCaptionL" fontSize="16px">
        Manufacturing Specs
      </Typography>
      <Stack gap="10px">
        <Stack direction="row" gap="10px">
          <HubMaterialHookSelect name="treeId" label="Tree Type" type="trees" />
          <HubHookFormSelect
            name="moldType"
            label="Mold Type"
            options={moldTypes}
            defaultValue={true}
            required
          />
          <HubHookFormInput
            name="partsPerTree"
            label="Parts / Tree"
            isNumber
            required
          />
        </Stack>
        <Stack direction="row" gap="10px">
          <HubHookFormSelect
            name="locationId"
            label="Location"
            options={FOUNDRIES}
            required
          />
          <HubMaterialHookSelect
            name="materialId"
            label="Metal Alloy"
            showOnlyGroup="Metal"
          />
        </Stack>
        <Stack direction="row" gap="10px">
          <FinancialPeriodSelect />
          <HubHookFormInput
            name="estimatedScrapRate"
            label="Est. Scrap Rate"
            placeholder="0"
            endAdornment="%"
            isDecimal
          />
        </Stack>
        <Stack direction="row" gap="10px">
          <HubHookFormSelect
            name="handBlasting"
            label="Hand Blasting"
            options={handBlastingOptions}
            useDefault
          />
          <HubHookFormInput
            name="gates"
            label="Gates"
            placeholder="ex. 4"
            isNumber
          />
          <HubHookFormSelect
            name="flushWitness"
            label="Grind Gate"
            options={grindGates}
            allowNull
          />
        </Stack>
        <StyledCheckboxGrid>
          {checkboxes.map((c) => (
            <HubHookFormSwitch
              name={c.id}
              key={c.id}
              label={c.label}
              labelPlacement="end"
              isCheckbox
            />
          ))}
        </StyledCheckboxGrid>
      </Stack>
    </Stack>

    <Stack gap="5px">
      <Typography variant="boldCaptionL" fontSize="16px">
        Pricing
      </Typography>
      <Stack gap="10px">
        <HubHookFormInput name="price" label="Quote Price" isCurrency />
        <HubHookFormInput
          name="notes"
          label="Notes"
          placeholder="Notes..."
          multiline
          rows={3}
        />
      </Stack>
    </Stack>
  </Stack>
);

export default QuoteDialogForm;
